import React from 'react';
import {
  BoxFileInterface,
  BoxItemInterface,
  BoxShareLinkInterface,
} from 'src/common/interfaces/integrations/box.interface';
import { Nullable } from 'src/types/nullable.type';

export const useBoxIntegration = () => {
  const fetchAllFiles = async (folderId: string = '0'): Promise<BoxFileInterface[]> => {
    const result: { entries: BoxItemInterface[] } = await window.paragon!.request('box', `/folders/${folderId}/items`, {
      method: 'GET',
    });

    let allFiles: BoxFileInterface[] = [];

    for (const item of result.entries) {
      if (item.type === 'folder') {
        const folderFiles = await fetchAllFiles(item.id);
        allFiles = allFiles.concat(folderFiles);
      } else {
        allFiles.push(item as BoxFileInterface);
      }
    }

    return allFiles;
  };

  const getShareLink = async (fileId: string) => {
    const result: { name: string; shared_link: { url: string; download_url: string } } = await window.paragon!.request(
      'box',
      `/files/${fileId}`,
      {
        method: 'PUT',
        body: JSON.stringify({ shared_link: { access: 'open' } }),
      }
    );
    return {
      url: result.shared_link.url,
      name: result.name,
      id: fileId,
    };
  };

  const getFileShareLinks = async (files: BoxFileInterface[]) => {
    const allLinks: Nullable<BoxShareLinkInterface>[] = await Promise.all(files.map((file) => getShareLink(file.id)));
    return allLinks.filter(Boolean) as BoxShareLinkInterface[];
  };

  return { fetchAllFiles, getFileShareLinks, getShareLink };
};
